import React from 'react';

import {
  SITES,
  NAV,
} from './utils';
const ModuleGeneratorHeader = ({doble, host, navegable,multipleModule, reset, setHost, setDouble, setNavegable }) => {
  return (
    <React.Fragment>
      <h1>Generador de módulos</h1>
      <button className="button" onClick={() => reset()}>
        Reset
      </button>

      <div className="generador-filters">
        {window.location.hostname === 'localhost' && (
          <div>
            <h4>Site</h4>
            <select
              onChange={(e) => {
                setHost(e.target.value);
              }}
              value={host}
            >
              {SITES.map((e) => (
                <option value={e} key={e}>
                  {e}
                </option>
              ))}
            </select>
          </div>
        )}
        <div>
          <h4>Navegable</h4>
          <select
            onChange={(e) => {
              setNavegable(e.target.value);
            }}
            value={navegable}
          >
            {NAV.map((e, i) => (
              <option value={i} key={i}>
                {e}
              </option>
            ))}
          </select>
        </div>
      </div>
      <div>
        <h3>Tipo de módulos</h3>
        <div className="buttonsContainer">
          {doble && (
            <button
              className={`button ${multipleModule && 'current'}`}
              onClick={() => setDouble(true)}
            >
              Módulo doble
            </button>
          )}
          <button
            className={`button ${!multipleModule && 'current'}`}
            onClick={() => setDouble(false)}
          >
            Módulos simples
          </button>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ModuleGeneratorHeader;
